import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import slick from "slick-carousel";
import PerfectScrollbar from "perfect-scrollbar";

/* ==============================================
ヘッダーの部分
============================================== */
export function servicesFunc() {
  let servicesTop = $("#servicesTop").length;

  if (servicesTop) {
    // subNavHeightFunc();

    subNavAccordionFuc();
    subNavScrollFunc();

    // function subNavHeightFunc() {
    //   let subNavHeight = $(".subNav");
    //   let headerHeight = $("#header").outerHeight();
    //   subNavHeight.css("top", `${headerHeight}px`);

    //   let setTimer = false;
    //   $(window).on("resize", function () {
    //     if (setTimer !== false) {
    //       clearTimeout(setTimer);
    //     }
    //     setTimer = setTimeout(() => {
    //       subNavHeightFunc();
    //     }, 200);
    //   });
    // }

    
    function subNavAccordionFuc() {
      const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
      const servicesSubNav = $("#servicesSubNavList a");
      let resizecheck = $("#responsibleCheck").width();
      let resizecheck2 = 0;

      $(window).on("load resize", function () {
        resizecheck = $("#responsibleCheck").width();
        subNavAccordionMenuStart();
        subNavCloseFunc();
      });

      //スマホのみサブナビをクリックでクローズさせる
      function subNavCloseFunc() {
        if (resizecheck == "2") {
          servicesSubNav.on("click", subNavClickHandler);
        } else if (resizecheck == "1") {
          servicesSubNav.off("click", subNavClickHandler);
        }
      }
      function subNavClickHandler() {
        servicesSubNavAccordionBtn.next("dd").slideUp(500);
        $("#servicesSubNav").removeClass("isNavOpen");
        servicesSubNavAccordionBtn.removeClass("isOpen");
      }
      subNavCloseFunc();

      servicesSubNavAccordionBtn.on("click", function () {
        const subNav = $("#servicesSubNav");

        if (resizecheck == "2") {
          if ($(this).hasClass("isOpen")) {
            $(this)
              .next("dd")
              .slideUp(500, function () {
                subNav.removeClass("isNavOpen");
              });
            $(this).removeClass("isOpen");
          } else {
            servicesSubNavAccordionBtn.next("dd").slideUp(500);
            servicesSubNavAccordionBtn.removeClass("isOpen");
            $(this).next("dd").slideDown(500);
            $(this).addClass("isOpen");

            subNav.addClass("isNavOpen");
          }
        }
      });

      var subNavAccordionMenuStart = function () {
        let resizecheck = $("#responsibleCheck").width();
        if (resizecheck == "2" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.next("dd").css("display", "none");
          resizecheck2 = 2;
        } else if (resizecheck == "1" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.removeClass("isOpen");
          servicesSubNavAccordionBtn.next("dd").css("display", "block");
          resizecheck2 = 1;
        }
      };
      subNavAccordionMenuStart();
    }

    function subNavScrollFunc() {
      // 今回の交差を監視する要素
      const boxes = document.querySelectorAll(".servicesList .list");

      const options = {
        root: null,
        rootMargin: "0% 0px -87%",
        threshold: 0,
      };
      const observer = new IntersectionObserver(doWhenIntersect, options);
      boxes.forEach((box) => {
        observer.observe(box);
      });

      /**
       * 交差したときに呼び出す関数
       * @param entries
       */
      function doWhenIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activateIndex(entry.target);
          }
        });
      }
      /**
       * 目次を変える関数
       * @param element
       */
      function activateIndex(element) {
        const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
        if (currentActiveIndex !== null) {
          currentActiveIndex.classList.remove("active");
        }
        const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
        newActiveIndex.classList.add("active");

        const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
        $("#navCurrent").text(currentTxt).css({ color: "#fff" });
      }
    }

    $(window).on("load scroll", function () {
      var subNavCurrent = $("#servicesSubNavList .pageLinkList");
      var scroll = $(window).scrollTop();
      if (scroll == 0) {
        $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
        if (subNavCurrent.hasClass("active")) {
          subNavCurrent.removeClass("active");
        }
      }
    });
  }
}

function getAnimationScroller() {
  const scrollContainer = document.querySelector(".scroll");
  return window.innerWidth <= 767 && scrollContainer ? scrollContainer : null;
}

function getScrollTriggerScrollerVars() {
  const scroller = getAnimationScroller();
  return scroller ? { scroller } : {};
}

const reloadScrollStorageKey = `cosmicprincesskaguya:scroll:${window.location.pathname}`;

const isReloadNavigation = () => {
  const navigationEntry = performance.getEntriesByType
    ? performance.getEntriesByType("navigation")[0]
    : null;

  if (navigationEntry) {
    return navigationEntry.type === "reload";
  }

  return performance.navigation && performance.navigation.type === 1;
};

if (isReloadNavigation()) {
  document.documentElement.classList.add("is-reloading");
}

const getScrollContainer = () => document.querySelector(".scroll");

const saveReloadScrollPosition = () => {
  const scrollContainer = getScrollContainer();

  try {
    sessionStorage.setItem(
      reloadScrollStorageKey,
      JSON.stringify({
        windowY: window.pageYOffset || 0,
        containerY: scrollContainer ? scrollContainer.scrollTop : 0,
      })
    );
  } catch (error) {
    // sessionStorage may be unavailable in private browsing modes.
  }
};

const getSavedReloadScrollPosition = () => {
  try {
    const savedPosition = sessionStorage.getItem(reloadScrollStorageKey);
    return savedPosition ? JSON.parse(savedPosition) : null;
  } catch (error) {
    return null;
  }
};

const clearSavedReloadScrollPosition = () => {
  try {
    sessionStorage.removeItem(reloadScrollStorageKey);
  } catch (error) {
    // Nothing to clear when sessionStorage is unavailable.
  }
};

const showFvAfterReloadRestore = () => {
  document.documentElement.classList.remove("is-reloading");
};

window.addEventListener("pagehide", saveReloadScrollPosition);
window.addEventListener("beforeunload", saveReloadScrollPosition);

export function animation() {
  gsap.registerPlugin(ScrollTrigger);

  let hasPlayedFvAnimation = false;
  const playFvAnimation = (includeLogo) => {
    const productTargets = ".fvProduct.iroha, .fvProduct.kaguya, .fvProduct.yachiyo";
    const logoTargets = ".fvLogo1, .fvLogo2, .fvCopyright";

    if (hasPlayedFvAnimation) {
      gsap.set(includeLogo ? `${productTargets}, ${logoTargets}` : productTargets, { autoAlpha: 1 });
      return;
    }

    hasPlayedFvAnimation = true;
    const tl = gsap.timeline();

    tl.fromTo(".fvProduct.iroha", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 });
    tl.fromTo(".fvProduct.kaguya", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 });
    tl.fromTo(".fvProduct.yachiyo", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 });

    if (includeLogo) {
      tl.fromTo(logoTargets, { autoAlpha: 0 }, { autoAlpha: 1, ease: "power1.inOut" }, "<1");
    }
  };

  let mm = gsap.matchMedia();

  // 共通のタイムライン設定
  mm.add("(min-width: 768px)", () => {
    // --- PC用の順番 ---
    playFvAnimation(true);
  });

  mm.add("(max-width: 767px)", () => {
    playFvAnimation(true);
  });

  // --- .fadeIn の処理 ---
  let fadeInTriggers = [];
  let detailWatchDialTriggers = [];

  const playProductItemsFadeIn = (target) => {
    if (!target.classList.contains("product") || target.dataset.productItemsAnimated === "true") return;
    target.dataset.productItemsAnimated = "true";

    gsap.to(target.querySelectorAll(".productItem"), {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      stagger: 0.5,
      ease: "power1.out",
    });
  };

  const playDetailWatchChangeImagesFadeIn = (target) => {
    if (!target.classList.contains("detailWatchChange") || target.dataset.changeImagesAnimated === "true") return;
    target.dataset.changeImagesAnimated = "true";

    gsap.to(target.querySelectorAll(".detailWatchChangeImg"), {
      autoAlpha: 1,
      duration: 0.8,
      stagger: 0.5,
      ease: "power1.out",
    });
  };

  const playDetailWatchItemAnimation = (target) => {
    if (!target.classList.contains("detailWatchItem") || target.dataset.watchItemAnimated === "true") return;
    target.dataset.watchItemAnimated = "true";

    const lineLeft = target.querySelector(".detailWatchItemNameLineLeft");
    const lineRight = target.querySelector(".detailWatchItemNameLineRight");
    const fadeTargets = target.querySelectorAll(
      ".detailWatchItemNameWrap, .detailWatchItemThumbnail, .detailWatchItemDesignWrap"
    );

    gsap
      .timeline()
      .to(
        lineLeft,
        {
          autoAlpha: 1,
          clipPath: "inset(0 0% 0 0)",
          duration: 1,
          ease: "power1.out",
        },
        0.65
      )
      .to(
        lineRight,
        {
          autoAlpha: 1,
          clipPath: "inset(0 0 0 0%)",
          duration: 1,
          ease: "power1.out",
        },
        0.65
      )
      .to(
        fadeTargets,
        {
          autoAlpha: 1,
          duration: 2,
          ease: "power1.out",
        },
        0.65
      );
  };

  const playDetailWatchDialFadeIn = (target) => {
    if (target.dataset.dialAnimated === "true") return;
    target.dataset.dialAnimated = "true";

    gsap.to(target, {
      autoAlpha: 1,
      duration: 0.8,
      ease: "power1.out",
    });
  };

  const getSpecialItemClipFrom = (target) => {
    return target.querySelector(".detailWatchSpecialItemBg.iroha")
      ? "inset(0 0 0 100%)"
      : "inset(0 100% 0 0)";
  };

  const getSpecialItemBgRect = (element) => {
    const rect = element.getBoundingClientRect();
    const parentRect = element.offsetParent
      ? element.offsetParent.getBoundingClientRect()
      : { left: 0 };

    return {
      left: rect.left - parentRect.left,
      width: rect.width,
    };
  };

  const forceRepaint = (element) => {
    if (!element) return;

    requestAnimationFrame(() => {
      const currentDisplay = element.style.display;
      element.style.display = "none";
      element.offsetHeight;
      element.style.display = currentDisplay;
    });
  };

  const playDetailWatchSpecialItemAnimation = (target) => {
    if (!target.classList.contains("detailWatchSpecialItem") || target.dataset.specialItemAnimated === "true") return;
    target.dataset.specialItemAnimated = "true";

    const bgTarget = target.querySelector(".detailWatchSpecialItemBg");
    const clipTargets = target.querySelectorAll(
      ".detailWatchSpecialItemDeco, .detailWatchSpecialItemLine"
    );
    const fadeTargets = target.querySelectorAll(
      ".detailWatchSpecialItemChara, .detailWatchSpecialItemName, .detailWatchSpecialItemImg"
    );
    const isIroha = Boolean(target.querySelector(".detailWatchSpecialItemBg.iroha"));
    const clipFrom = getSpecialItemClipFrom(target);
    const bgRect = getSpecialItemBgRect(bgTarget);

    gsap
      .timeline({
        onComplete: () => {
          forceRepaint(bgTarget);
        },
      })
      .fromTo(
        bgTarget,
        {
          width: 0,
          left: isIroha ? bgRect.left + bgRect.width : bgRect.left,
          right: "auto",
        },
        {
          width: bgRect.width,
          left: bgRect.left,
          duration: 1,
          ease: "power1.out",
          force3D: false,
          onComplete: () => {
            gsap.set(bgTarget, { clearProps: "width,left,right,transform" });
            forceRepaint(bgTarget);
          },
        }
      )
      .fromTo(
        clipTargets,
        { clipPath: clipFrom },
        {
          clipPath: "inset(0 0% 0 0%)",
          duration: 1,
          ease: "power1.out",
          stagger: 0.12,
          onComplete: () => {
            gsap.set(clipTargets, { clearProps: "clipPath" });
          },
        },
        "<"
      )
      .to(
        fadeTargets,
        {
          autoAlpha: 1,
          duration: 0.8,
          stagger: 0.12,
          ease: "power1.out",
        },
        "-=0.15"
      );
  };

  const getStandSpecialItemClipFrom = (target) => {
    return target.querySelector(".detailStandSpecialItemBg.iroha")
      ? "inset(0 0 0 100%)"
      : "inset(0 100% 0 0)";
  };

  const playDetailStandSpecialItemAnimation = (target) => {
    if (!target.classList.contains("detailStandSpecialItem") || target.dataset.standSpecialItemAnimated === "true") return;
    target.dataset.standSpecialItemAnimated = "true";

    const bgTarget = target.querySelector(".detailStandSpecialItemBg");
    const clipTargets = target.querySelectorAll(
      ".detailStandSpecialItemDeco, .detailStandSpecialItemLine"
    );
    const fadeTargets = target.querySelectorAll(
      ".detailStandSpecialItemName, .detailStandSpecialItemImg"
    );
    const isIroha = Boolean(target.querySelector(".detailStandSpecialItemBg.iroha"));
    const clipFrom = getStandSpecialItemClipFrom(target);
    const bgRect = getSpecialItemBgRect(bgTarget);

    gsap
      .timeline({
        onComplete: () => {
          forceRepaint(bgTarget);
        },
      })
      .fromTo(
        bgTarget,
        {
          width: 0,
          left: isIroha ? bgRect.left + bgRect.width : bgRect.left,
          right: "auto",
        },
        {
          width: bgRect.width,
          left: bgRect.left,
          duration: 1,
          ease: "power1.out",
          force3D: false,
          onComplete: () => {
            gsap.set(bgTarget, { clearProps: "width,left,right,transform" });
            forceRepaint(bgTarget);
          },
        }
      )
      .fromTo(
        clipTargets,
        { clipPath: clipFrom },
        {
          clipPath: "inset(0 0% 0 0%)",
          duration: 1,
          ease: "power1.out",
          stagger: 0.12,
          onComplete: () => {
            gsap.set(clipTargets, { clearProps: "clipPath" });
          },
        },
        "<"
      )
      .to(
        fadeTargets,
        {
          autoAlpha: 1,
          duration: 0.8,
          stagger: 0.12,
          ease: "power1.out",
        },
        "-=0.15"
      );
  };

  gsap.set(".product .productItem", {
    autoAlpha: 0,
  });

  gsap.set(".detailWatchChange .detailWatchChangeImg", {
    autoAlpha: 0,
  });

  // 背景・キャラクター・右側装飾は最初から表示し、それ以外を段階的に表示する。
  gsap.set(".detailWatchItem", {
    autoAlpha: 1,
  });

  gsap.set(".detailWatchItemNameLineLeft", {
    autoAlpha: 0,
    clipPath: "inset(0 100% 0 0)",
  });

  gsap.set(".detailWatchItemNameLineRight", {
    autoAlpha: 0,
    clipPath: "inset(0 0 0 100%)",
  });

  gsap.set(
    ".detailWatchItemNameWrap, .detailWatchItemThumbnail, .detailWatchItemDesignWrap, .detailWatchItemDialWrap",
    {
      autoAlpha: 0,
    }
  );

  gsap.set(".detailWatchSpecialItemDeco, .detailWatchSpecialItemLine", {
    clipPath: "inset(0 100% 0 0)",
  });

  gsap.set(
    ".detailWatchSpecialItemChara, .detailWatchSpecialItemName, .detailWatchSpecialItemImg",
    {
      autoAlpha: 0,
    }
  );

  gsap.set(".detailStandSpecialItemDeco, .detailStandSpecialItemLine", {
    clipPath: "inset(0 100% 0 0)",
  });

  gsap.set(".detailStandSpecialItemName, .detailStandSpecialItemImg", {
    autoAlpha: 0,
  });

  const setupFadeInTriggers = () => {
    fadeInTriggers.forEach((trigger) => trigger.kill());
    fadeInTriggers = [];
    detailWatchDialTriggers.forEach((trigger) => trigger.kill());
    detailWatchDialTriggers = [];

    const scrollTriggerScrollerVars = getScrollTriggerScrollerVars();
    gsap.utils.toArray(".fadeIn").forEach((target) => {
      fadeInTriggers.push(
        ScrollTrigger.create({
          trigger: target,
          start: "top 50%",
          onEnter: () => {
            target.classList.add("active");
            playProductItemsFadeIn(target);
            playDetailWatchChangeImagesFadeIn(target);
            playDetailWatchItemAnimation(target);
            playDetailWatchSpecialItemAnimation(target);
            playDetailStandSpecialItemAnimation(target);
          },
          onEnterBack: () => {
            target.classList.add("active");
            playProductItemsFadeIn(target);
            playDetailWatchChangeImagesFadeIn(target);
            playDetailWatchItemAnimation(target);
            playDetailWatchSpecialItemAnimation(target);
            playDetailStandSpecialItemAnimation(target);
          },
          // markers:true,
          ...scrollTriggerScrollerVars,
        })
      );
    });

    gsap.utils.toArray(".detailWatchItemDialWrap").forEach((target) => {
      detailWatchDialTriggers.push(
        ScrollTrigger.create({
          trigger: target,
          start: "top 80%",
          onEnter: () => playDetailWatchDialFadeIn(target),
          onEnterBack: () => playDetailWatchDialFadeIn(target),
          ...scrollTriggerScrollerVars,
        })
      );
    });
  };

  setupFadeInTriggers();

  // 背景切り替え
  const fixedBgWrap = document.querySelector(".fixedProductBgWrap");
  const fixedBg = document.querySelector(".fixedProductBg");
  const firstProduct = document.querySelector(".product.first");

const bgSections = [
  {
    selector: ".product",
    key: "product",
  },
  {
    selector: ".detailWatch",
    key: "detailWatch",
  },
  {
    selector: ".detailStand",
    key: "detailStand",
  },
  {
    selector: ".campaign",
    key: "campaign",
  },
  {
    selector: ".product.second",
    key: "prodcutSecond",
  },
  {
    selector: ".shopList",
    key: "shopList",
  },
];

const bgLayers = {};
let currentActiveKey = "";
let isSp = window.innerWidth <= 767;

const getBgSectionTargets = () =>
  bgSections
    .map((section) => ({
      ...section,
      target: document.querySelector(section.selector),
    }))
    .filter((section) => section.target);

const getBgImages = () => {
  if (window.innerWidth <= 767) {
    return {
      product:
        "/s/garrack/feature/cosmicprincesskaguya/images/product/product-bg-sp.png",
      detailWatch:
        "/s/garrack/feature/cosmicprincesskaguya/images/detailWatch/detailWatch-fixed-bg-sp.png",
      detailStand:
        "/s/garrack/feature/cosmicprincesskaguya/images/detailStand/detailStand-fixed-bg-sp.png",
      campaign:
        "/s/garrack/feature/cosmicprincesskaguya/images/campaign/campaign-fixed-bg-sp.png",
      prodcutSecond:
        "/s/garrack/feature/cosmicprincesskaguya/images/product/product-bg-sp.png",
      shopList:
        "/s/garrack/feature/cosmicprincesskaguya/images/shoplist/shoplist-fixed-bg-sp.png",
    };
  }

  return {
    product:
      "/s/garrack/feature/cosmicprincesskaguya/images/product/product-bg@1x.png",
    detailWatch:
      "/s/garrack/feature/cosmicprincesskaguya/images/detailWatch/detailWatch-fixed-bg@1x.png",
    detailStand:
      "/s/garrack/feature/cosmicprincesskaguya/images/detailStand/detailStand-fixed-bg@1x.png",
    campaign:
      "/s/garrack/feature/cosmicprincesskaguya/images/campaign/campaign-fixed-bg@1x.png",
    prodcutSecond:
      "/s/garrack/feature/cosmicprincesskaguya/images/product/product-bg@1x.png",
    shopList:
      "/s/garrack/feature/cosmicprincesskaguya/images/shoplist/shoplist-fixed-bg@1x.png",
  };
};

const createBgLayers = () => {
  if (!fixedBg) return;

  fixedBg.innerHTML = "";

  Object.keys(bgLayers).forEach((key) => delete bgLayers[key]);

  const bgImages = getBgImages();

  Object.entries(bgImages).forEach(([key, image]) => {
    const layer = document.createElement("div");

    layer.className = `fixedProductBgLayer fixedProductBgLayer-${key}`;

    Object.assign(layer.style, {
      position: "absolute",
      inset: "0",
      backgroundImage: `url(${image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      opacity: "0",
      transition: "opacity 0.8s ease",
    });

    fixedBg.appendChild(layer);
    bgLayers[key] = layer;
  });
};

createBgLayers();

const switchFixedBg = () => {
  if (!fixedBg) return;

  const switchLine = window.innerHeight * 0.6;
  let activeKey = "";
  const sectionTargets = getBgSectionTargets();

  sectionTargets.forEach(({ key, target }) => {
    const rect = target.getBoundingClientRect();

    if (rect.top <= switchLine && rect.bottom > switchLine) {
      activeKey = key;
    }
  });

  if (activeKey) {
    currentActiveKey = activeKey;
  }

  if (fixedBgWrap) {
    fixedBgWrap.classList.toggle(
      // "is-first-product",
      currentActiveKey === "" || currentActiveKey === "product"
    );
  }

  
  if (firstProduct) {
    firstProduct.classList.toggle(
      // "is-fixed-bg-started",
      currentActiveKey === "product"
    );
  }

  fixedBg.classList.toggle("is-active", Boolean(currentActiveKey));

  sectionTargets.forEach(({ key, target }) => {
    const isActiveSection = currentActiveKey === key;

    target.classList.toggle("is-current-bg-section", isActiveSection);
    target.classList.toggle(
      "is-muted-bg-section",
      Boolean(currentActiveKey) && !isActiveSection
    );
  });

  Object.entries(bgLayers).forEach(([key, layer]) => {
    layer.style.opacity = currentActiveKey === key ? "1" : "0";
  });
};

const getCurrentScrollTop = (isScrollSp) => {
  const scrollContainer = document.querySelector(".scroll");
  return isScrollSp && scrollContainer ? scrollContainer.scrollTop : window.pageYOffset;
};

const setCurrentScrollTop = (isScrollSp, scrollTop) => {
  const scrollContainer = document.querySelector(".scroll");

  if (isScrollSp && scrollContainer) {
    scrollContainer.scrollTop = scrollTop;
  } else {
    window.scrollTo(0, scrollTop);
  }
};

const getProductHeaderResizeAnchor = () => {
  const header = document.querySelector(".productHeader");
  const detailWatch = document.querySelector(".detailWatch");
  const detailWrap = document.querySelector(".detailWrap");

  if (!detailWatch || !detailWrap) return null;

  const detailWatchRect = detailWatch.getBoundingClientRect();
  const detailWrapRect = detailWrap.getBoundingClientRect();
  const isProductAreaVisible = detailWatchRect.top < window.innerHeight && detailWrapRect.bottom > 0;
  const isHeaderFixed = header && header.classList.contains("is-fixed");

  if (!isProductAreaVisible && !isHeaderFixed) return null;

  return {
    element: detailWatch,
    top: detailWatchRect.top,
  };
};

const keepResizeAnchorPosition = (anchor, isScrollSp) => {
  if (!anchor || !anchor.element) return;

  const currentTop = anchor.element.getBoundingClientRect().top;
  const scrollTop = getCurrentScrollTop(isScrollSp);
  const nextScrollTop = scrollTop + currentTop - anchor.top;

  setCurrentScrollTop(isScrollSp, nextScrollTop);
};

let productHeaderResizeAnchor = null;
const captureProductHeaderResizeAnchor = () => {
  productHeaderResizeAnchor = getProductHeaderResizeAnchor();
};

let backgroundScrollTarget = null;
const onBackgroundScroll = () => {
  switchFixedBg();
  ScrollTrigger.update();
  captureProductHeaderResizeAnchor();
};

const setupBackgroundScrollListener = () => {
  if (backgroundScrollTarget) {
    backgroundScrollTarget.removeEventListener("scroll", onBackgroundScroll);
  }

  backgroundScrollTarget = getAnimationScroller() || window;
  backgroundScrollTarget.addEventListener("scroll", onBackgroundScroll);
};

let currentProductHeaderIsSp = isSp;
setupBackgroundScrollListener();
captureProductHeaderResizeAnchor();

window.addEventListener("resize", () => {
  const currentIsSp = window.innerWidth <= 767;
  const previousIsSp = isSp;
  const previousScrollTop = getCurrentScrollTop(previousIsSp);
  const resizeAnchor = productHeaderResizeAnchor;

  if (currentIsSp !== isSp) {
    isSp = currentIsSp;
    createBgLayers();
    setupBackgroundScrollListener();
  }

  if (currentIsSp !== currentProductHeaderIsSp) {
    currentProductHeaderIsSp = currentIsSp;
    setupFadeInTriggers();
    setupProductHeaderPin();
  }

  if (currentIsSp !== previousIsSp) {
    requestAnimationFrame(() => {
      if (resizeAnchor) {
        keepResizeAnchorPosition(resizeAnchor, currentIsSp);
      } else {
        setCurrentScrollTop(currentIsSp, previousScrollTop);
      }
      switchFixedBg();
      ScrollTrigger.refresh();
      captureProductHeaderResizeAnchor();
    });
  } else {
    requestAnimationFrame(() => {
      keepResizeAnchorPosition(resizeAnchor, currentIsSp);
      switchFixedBg();
      ScrollTrigger.refresh();
      captureProductHeaderResizeAnchor();
    });
  }
});

switchFixedBg();

  setupProductHeaderPin();
  restoreScrollPositionAfterReload();
  // 製品情報背景切り替え（SP）
  // window.addEventListener("scroll", () => {
  //   const start = document.getElementById("js-bg-start-top-sp");
  //   const end = document.getElementById("js-bg-end-top-sp");
  //   const fixedBg = document.querySelector(".fixedMidBgSp");

  //   if (!start || !end || !fixedBg) return;

  //   const startTop = start.getBoundingClientRect().top;
  //   const endTop = end.getBoundingClientRect().top;

  //   // start通過 && end未到達
  //   const isActive = startTop <= 0 && endTop > 0;

  //   fixedBg.classList.toggle("is-second", isActive);
  // });
}

function restoreScrollPositionAfterReload() {
  if (!isReloadNavigation()) {
    clearSavedReloadScrollPosition();
    showFvAfterReloadRestore();
    return;
  }

  const savedPosition = getSavedReloadScrollPosition();

  if (!savedPosition) {
    showFvAfterReloadRestore();
    return;
  }

  const restoreTop = () => {
    const isScrollSp = window.innerWidth <= 767;
    const scrollContainer = getScrollContainer();
    const scrollTop = isScrollSp
      ? savedPosition.containerY
      : savedPosition.windowY || savedPosition.containerY;

    if (isScrollSp && scrollContainer) {
      scrollContainer.scrollTop = scrollTop || 0;
    } else {
      window.scrollTo(0, scrollTop || 0);
    }

    ScrollTrigger.refresh();
    ScrollTrigger.update();
  };

  requestAnimationFrame(() => {
    restoreTop();
    showFvAfterReloadRestore();
  });
  window.setTimeout(restoreTop, 100);
  window.setTimeout(restoreTop, 400);
  window.setTimeout(() => {
    restoreTop();
    clearSavedReloadScrollPosition();
  }, 900);
}

function setupProductHeaderPin() {
  const header = document.querySelector(".productHeader");
  const detailWatch = document.querySelector(".detailWatch");
  const detailWrap = document.querySelector(".detailWrap");
  const campaign = document.querySelector(".campaign");
  const productHeaderVisibilityMarker = document.getElementById("productHeaderVisibilityMarker");

  if (!header || !detailWatch || !detailWrap || !productHeaderVisibilityMarker) return;

  const headerEndTrigger = campaign || detailWrap;

  const pinTrigger = ScrollTrigger.getById("productHeaderPin");
  const visibilityTrigger = ScrollTrigger.getById("productHeaderVisibility");

  if (pinTrigger) {
    pinTrigger.kill();
  }

  if (visibilityTrigger) {
    visibilityTrigger.kill();
  }

  const spacer =
    header.previousElementSibling && header.previousElementSibling.classList.contains("productHeaderSpacer")
      ? header.previousElementSibling
      : document.createElement("div");

  if (!spacer.classList.contains("productHeaderSpacer")) {
    spacer.className = "productHeaderSpacer";
    header.parentNode.insertBefore(spacer, header);
  }

  const setSpacerHeight = () => {
    spacer.style.height = `${header.offsetHeight}px`;
  };

  const clearSpacerHeight = () => {
    spacer.style.height = "0px";
  };

  const cancelHeaderReset = () => {
    if (!setupProductHeaderPin._resetHeaderTimer) return;

    clearTimeout(setupProductHeaderPin._resetHeaderTimer);
    setupProductHeaderPin._resetHeaderTimer = null;
  };

  const showHeader = () => {
    cancelHeaderReset();
    setSpacerHeight();
    header.classList.add("is-fixed");
    header.classList.remove("is-hide");
  };

  const showHeaderWithoutTransition = () => {
    cancelHeaderReset();
    setSpacerHeight();
    header.style.transition = "none";
    header.classList.add("is-fixed");
    header.classList.remove("is-hide");
    header.offsetHeight;

    requestAnimationFrame(() => {
      header.style.transition = "";
    });
  };

  const hideHeader = () => {
    setSpacerHeight();
    header.classList.add("is-hide");
  };

  const resetHeader = () => {
    cancelHeaderReset();
    setSpacerHeight();
    header.classList.add("is-hide");

    // 固定位置のままフェードアウトさせてから通常配置へ戻す。
    // 即座に is-fixed を外すと transition 前に位置が切り替わり、上スクロール時にカクつく。
    setupProductHeaderPin._resetHeaderTimer = setTimeout(() => {
      setupProductHeaderPin._resetHeaderTimer = null;

      if (!header.classList.contains("is-hide")) return;

      header.classList.remove("is-fixed");
      clearSpacerHeight();
    }, 400);
  };

  const getProductHeaderOffset = () => {
    const headerBgStyle = window.getComputedStyle(header, "::before");
    const headerBgTop = parseFloat(headerBgStyle.top) || 0;
    const headerBgHeight = parseFloat(headerBgStyle.height) || header.offsetHeight || 0;
    const margin = window.innerWidth <= 767 ? 30 : 170;

    return Math.ceil(headerBgTop + headerBgHeight + margin);
  };

  const getProductHeaderVisibilityStart = () => {
    return `top ${getProductHeaderOffset()}px`;
  };

  ScrollTrigger.create({
    id: "productHeaderVisibility",
    trigger: productHeaderVisibilityMarker,
    start: getProductHeaderVisibilityStart,
    endTrigger: headerEndTrigger,
    end: "top 60%",
    invalidateOnRefresh: true,
    onEnter: () => {
      showHeader();
    },
    onLeave: () => {
      hideHeader();
    },
    onEnterBack: () => {
      showHeaderWithoutTransition();
    },
    onLeaveBack: () => {
      resetHeader();
    },
    ...getScrollTriggerScrollerVars(),
  });

  let refreshTimer = null;
  const refreshProductHeader = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      requestAnimationFrame(() => {
        if (header.classList.contains("is-fixed")) {
          setSpacerHeight();
        }

        ScrollTrigger.refresh();
      });
    }, 100);
  };

  refreshProductHeader();

  window.addEventListener("load", refreshProductHeader, { once: true });

  if (setupProductHeaderPin._refreshProductHeader) {
    window.removeEventListener("resize", setupProductHeaderPin._refreshProductHeader);
  }

  setupProductHeaderPin._refreshProductHeader = refreshProductHeader;
  window.addEventListener("resize", refreshProductHeader);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      refreshProductHeader();
    });
  }

  const productImages = detailWrap.querySelectorAll("img");
  productImages.forEach((image) => {
    if (image.complete) return;

    image.addEventListener("load", refreshProductHeader, { once: true });
    image.addEventListener("error", refreshProductHeader, { once: true });
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });

  ScrollTrigger.config({
    ignoreMobileResize: true,
  });
}

// // 製品情報アンカーリンク追従（SP）
// document.addEventListener("DOMContentLoaded", () => {
//   gsap.registerPlugin(ScrollTrigger);

//   const header = document.querySelector(".productHeaderSp");

//   ScrollTrigger.create({
//     trigger: ".productHeaderSp",
//     start: "top+=1 top",
//     endTrigger: ".productSp",
//     end: "bottom top",

//     pin: header,
//     pinSpacing: false,

//     invalidateOnRefresh: true,
//     anticipatePin: 1,

//     onEnter: () => {
//       header.classList.add("is-fixed");
//       header.classList.remove("is-hide");
//     },

//     onLeave: () => {
//       header.classList.add("is-hide");
//     },

//     onEnterBack: () => {
//       header.classList.remove("is-hide");
//     },

//     onLeaveBack: () => {
//       header.classList.remove("is-fixed");
//     },
//   });
//   window.addEventListener("load", () => {
//     ScrollTrigger.refresh();
//   });
//   ScrollTrigger.config({
//     ignoreMobileResize: true,
//   });
// });

export function slide() {
  // 追従ボタン
  const scrollContainer = document.querySelector(".scroll");
  const trigger = document.getElementById("js-floating-start");
  const triggerEnd = document.getElementById("js-floating-end");
  const fixContent = document.getElementById("fixedBtnWrap");

  if (!scrollContainer || !trigger || !triggerEnd || !fixContent) return;

  const updateFixedBtn = () => {
    const scrollValue = scrollContainer.scrollTop;
    const containerHeight = scrollContainer.clientHeight;
    const startPos = trigger.offsetTop;
    const endPos = triggerEnd.offsetTop;

    const isStarted = scrollValue > startPos;
    const isNotReachedEnd = scrollValue + containerHeight < endPos;

    fixContent.classList.toggle("is-show", isStarted && isNotReachedEnd);
  };

  updateFixedBtn();
  scrollContainer.addEventListener("scroll", updateFixedBtn);
  window.addEventListener("resize", updateFixedBtn);
}
export function scrollBar() {
  window.addEventListener("load", function () {
    const targets = document.querySelectorAll(".detailMainItemLineScrollWrapSp.buggy,.detailMainItemLineScrollWrapSp.teach");
    const initScrollbar = () => {
      const isSP = window.innerWidth <= 767;

      targets.forEach((target) => {
        if (isSP) {
          // SP（767以下）のとき → PerfectScrollbar 有効化
          if (!target._ps) {
            target._ps = new PerfectScrollbar(target, {
              suppressScrollY: true, // 縦スクロール無効化
            });

            target.addEventListener("click", function () {
              target.classList.add("isActive");
              target._ps.update();
            });
          }
        } else {
          // PC（768以上）のとき → PerfectScrollbar 無効化
          if (target._ps) {
            target._ps.destroy();
            target._ps = null;
          }
        }
      });
    };

    // 初期化
    initScrollbar();

    // リサイズ対応
    window.addEventListener("resize", initScrollbar);
  });
}
